import React from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { get } from "lodash";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./StoreInfoManager.css";
import ProSourceForm from "../components/ProSourceForm";
import { FormItem } from "../components/Base";
import { GetSubmitClassList } from "../helpers";
import { RESERVATION_COLOR } from "../constants";

const CANCELLATION_POLICY_TOOLBAR = [
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
  ["clean"],
];

export default class StoreInfoManager extends ProSourceForm {
  constructor(props) {
    super(props);

    const { store } = this.props;

    this.state = {
      values: {
        store_description: store.store_description || "",
        reservation_info:
          get(store, "reservation_info.value", "") ||
          store.reservation_info ||
          "",
        reservation_cancellation_policy:
          store.reservation_cancellation_policy || "",
      },
      errors: {},
      touched: {},
      isSubmitting: false,
    };
  }

  onSubmit = (values, setSubmitting) => {
    const payload = {
      ...values,
      reservation_info: {
        type: "info",
        value: values.reservation_info,
      },
    };

    this.props.onSubmit(payload, setSubmitting);
  };

  // Quill never reports an empty editor as "" (it emits "<p><br></p>"), so check the text
  handleCancellationPolicyChange = (html, delta, source, editor) => {
    this.setFieldValue(
      "reservation_cancellation_policy",
      editor.getText().trim() ? html : "",
    );
  };

  handleCancellationPolicyBlur = () => {
    this.setStateKey("touched", "reservation_cancellation_policy", true);
  };

  render() {
    const { isSubmitting, values } = this.state;
    const actions = {
      handleFeedbackError: this.handleFeedbackError,
      isTouched: this.isTouched,
    };
    const inputActions = {
      onChange: this.handleOnChange,
      onBlur: this.handleOnBlur,
    };

    return (
      <Card
        className="d-flex justify-content-between w-100 mt-4"
        style={{ borderTop: `5px solid ${RESERVATION_COLOR}` }}
      >
        <Card.Header className="font-weight-boldest">
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ transform: "scale(1.2)" }}>Store Information</div>
          </div>
        </Card.Header>
        <Form onSubmit={this.handleOnSubmit}>
          <Card.Body>
            <Row>
              <Col md={6}>
                <FormItem
                  label="About Us"
                  name="store_description"
                  customFormControl
                  custom={
                    <Form.Control
                      as="textarea"
                      rows={8}
                      name="store_description"
                      placeholder="Tell us about your store..."
                      value={values.store_description}
                      {...inputActions}
                    />
                  }
                  actions={actions}
                />
              </Col>
              <Col md={6}>
                <FormItem
                  label="Reservation Info"
                  name="reservation_info"
                  customFormControl
                  custom={
                    <Form.Control
                      as="textarea"
                      rows={8}
                      name="reservation_info"
                      placeholder="Enter reservation terms and conditions..."
                      value={values.reservation_info}
                      {...inputActions}
                    />
                  }
                  actions={actions}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormItem
                  label="Cancellation Policy"
                  name="reservation_cancellation_policy"
                  customFormControl
                  custom={
                    <ReactQuill
                      theme="snow"
                      className="cancellation-policy-editor"
                      placeholder="Enter cancellation policy..."
                      value={values.reservation_cancellation_policy}
                      onChange={this.handleCancellationPolicyChange}
                      onBlur={this.handleCancellationPolicyBlur}
                      modules={{ toolbar: CANCELLATION_POLICY_TOOLBAR }}
                    />
                  }
                  actions={actions}
                />
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="text-right">
            <Button
              type="submit"
              className={GetSubmitClassList(isSubmitting, "")}
              disabled={isSubmitting}
              style={{
                backgroundColor: RESERVATION_COLOR,
                borderColor: RESERVATION_COLOR,
              }}
            >
              {isSubmitting ? "Saving..." : "Save Store Information"}
            </Button>
          </Card.Footer>
        </Form>
      </Card>
    );
  }
}
